import React from 'react';

class Feature extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    /**
     * Your ajax will goes here to get data then call setState
     */
  }

  render() {
    return (
      <React.Fragment>
        <section
          id="features"
          className="about-us ptb-100 background-shape-img"
        >
          <div className="container">
            <div className="row align-items-center">
              <div className="col-md-6">
                <div className="row align-items-center ptb-100">
                  <h2 className="mt-4">Frisbee Business Portal</h2>
                  <div className="col-lg-12">
                    <div className="d-flex align-items-start mb-5">
                      <div className="pr-4">
                        <div className="icon icon-shape icon-color-1 rounded-circle">
                          <span className="ti-vector"></span>
                        </div>
                      </div>
                      <div className="icon-text">
                        <h5>Administra tu Negocio</h5>
                        <p className="mb-0">
                          Te ayudamos a cargar, configurar y actualizar tu inventario.
                          Nuestra plataforma optimiza tus productos con estrategias SEO para aumentar tus ventas.
                        </p>
                      </div>
                    </div>
                    <div className="d-flex align-items-start mb-5">
                      <div className="pr-4">
                        <div className="icon icon-shape icon-color-2 rounded-circle">
                          <span className="ti-face-smile"></span>
                        </div>
                      </div>
                      <div className="icon-text">
                        <h5>Fideliza tus clientes</h5>
                        <p className="mb-0">
                          Crea descuentos, gift cards, vouchers y participa en Flash Sales para
                          fidelizar a tus clientes más especiales. Te damos las herramientas para 
                          que sigas creciendo la relación con tus mejores clientes.
                        </p>
                      </div>
                    </div>
                    <div className="d-flex align-items-start mb-5">
                      <div className="pr-4">
                        <div className="icon icon-shape icon-color-4 rounded-circle">
                          <span className="ti-bar-chart"></span>
                        </div>
                      </div>
                      <div className="icon-text">
                        <h5>Toma mejores decisiones</h5>
                        <p className="mb-0">
                          Visualiza información que te ayuda a tomar mejores decisiones en tu negocio.
                          Te damos las herramientas para que analices tu tráfico, ventas, productos y puedas tener el producto que tus clientes buscan.
                        </p>
                      </div>
                    </div>
                    <div className="d-flex align-items-start mb-5">
                      <div className="pr-4">
                        <div className="icon icon-shape icon-color-3 rounded-circle">
                          <span className="ti-gallery"></span>
                        </div>
                      </div>
                      <div className="icon-text">
                        <h5>Maneja tus productos</h5>
                        <p className="mb-0">
                          Nuestra plataforma es muy flexible para diferentes tipos de productos, con atributos diferentes y variaciones 
                          por referencia. Carga las mejores fotos de tu producto, descríbelo y véndelo con tús políticas. 
                          Sincronizamos el stock y precio en tiempo real para ofrecer una experiencia omnicanal.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="about-content-right">
                    <img
                      src="img/service3.jpg"
                      alt="Frisbee Business Portal"
                      className="img-fluid"
                    />
                </div>
              </div>
            </div>
          </div>
        </section>
      </React.Fragment>
    );
  }
}

export default Feature;
